import reducer from './reducers';
import * as types from './types';
import * as actions from './actions';
import { sagas } from './sagas';

// eslint-disable-next-line import/no-unused-modules
export { types, actions, sagas };

export default reducer;
